import React, { useEffect } from 'react';
import { Button } from '@naf-simba/elements-buttons';
import { useDispatch } from 'react-redux';
import useSelector from '@redux/typedHooks';
import { actions as carFilterActions } from '@redux/modules/carFilter';
import { actions as carsActions } from '@redux/modules/cars';
import { createElbilguideAPIQuery } from '@utils/bilguide';
import { getURLParams } from '@lib/getUrlParams';
import CarSubList from './CarSubList';
import { CarSubListPlaceholder } from './CarSubListPlaceholder';
import { ShowMoreButtonWrapper } from './CarList.styles';

const CarList = () => {
  const dispatch = useDispatch();

  const cars = useSelector((state) => state.cars);
  const { vehicleCounts, data: dataIds, mappedData } = cars;
  const data = dataIds.map((sublist) => sublist.map((id) => mappedData[id].data));
  const { filterNumber, filterFetched } = useSelector((state) => state.carFilter);
  const isUpdating = useSelector((state) => state.cars.isUpdating);
  const isAppending = useSelector((state) => state.cars.isAppending);

  // Fetch cars whenever the filter version changes (filter / sort / search) or when no data is available.
  // Don't gate on isUpdating: it is true in the initial state without a request, so client-side navigation would never fetch.
  useEffect(() => {
    if (filterFetched) return;
    if (filterNumber === 1 && dataIds[0]?.length > 0) return;
    const queries = createElbilguideAPIQuery(getURLParams());
    dispatch(carsActions.getCars.request(queries));
    dispatch(carFilterActions.setDidRefreshSearch());
  }, [filterNumber, filterFetched, dataIds, dispatch]);

  const carsCount = data.reduce((acc: number, element: any) => acc + element.length, 0);

  const onShowMoreBtnClick = () => {
    const queries = createElbilguideAPIQuery(getURLParams());
    dispatch(carsActions.getMoreCars.request(`${queries}&skip=${carsCount}&take=30`));
  };

  return (
    <>
      {isUpdating ? (
        <CarSubList cars={data[0] ?? []} key="car-sub-list-skeleton" isUpdating />
      ) : (
        <>
          {data.map((carList, i) => (
            <CarSubList cars={carList} key={`car-sub-list-${carList[0]?.id || i}`} isUpdating={false} />
          ))}
          {isAppending && <CarSubListPlaceholder />}
        </>
      )}
      {carsCount < vehicleCounts ? (
        <ShowMoreButtonWrapper>
          {carsCount < vehicleCounts && (
            <Button variant="outlined" onClick={onShowMoreBtnClick}>
              Vis flere
            </Button>
          )}
          <p>
            Viser {carsCount} av {vehicleCounts}
          </p>
        </ShowMoreButtonWrapper>
      ) : (
        <p>
          Viser {carsCount} av {vehicleCounts}
        </p>
      )}
    </>
  );
};

export default CarList;
